// Libs
import React from 'react'
import PropTypes from 'prop-types'
import _size from 'lodash/size'
import _map from 'lodash/map'

// PropTypes
import {
  selectedRecords as selectedRecordsPropTypes,
} from './propTypes'

// Styles
import { white, primary, grey } from 'fc-styles/src/colors'
import {
  barStyle,
} from './styles'

// Components
import CloseIcon from 'fc-icons/src/Close'
import FilterIcon from 'fc-icons/src/Filter'

const filterIcon = <FilterIcon size={12} color={white()} />

// Local Styles
const barLeftStyle = { display: 'flex' }
const barRightStyle = { display: 'flex', justifyContent: 'flex-end', flex: '1 1 auto' }
const widgetStyle = { display: 'flex', alignItems: 'center', borderRadius: 2, marginRight: 10 }
const closeBtnStyle = { cursor: 'pointer', padding: '5px 7px', backgroundColor: white() }
const recordCountStyle = {
  padding: '5px 7px',
  color: white(),
  backgroundColor: primary(),
  display: 'flex',
  alignItems: 'center',
}

const closeIcon = <CloseIcon size={16} color={grey()} />

// Local Components
const Widget = ({label, children, onClick}) => (
  <div style={widgetStyle}>
    <div style={closeBtnStyle} onClick={onClick}>
      {label}
    </div>
    <div style={recordCountStyle}>
      {children}
    </div>
  </div>
)

Widget.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
}

// Exports
export const TableBar = ({
  children, selectedRecords, filters, onClearSelection, onFilter, Bar, smallScreen, hideSelectAll,
}) => {
  if (!Bar && smallScreen) {
    return null
  }

  const count = _size(selectedRecords)

  const counterWidget = count && !hideSelectAll
    ? (<Widget key={'_count'} label={closeIcon} onClick={onClearSelection}>
      <span>{count} selected</span>
    </Widget>
      )
    : null

  const filterWidgets = _map(filters, (value, attr) => {
    if (value) {
      return (
        <Widget
          key={`_filter_${attr}`}
          label={closeIcon}
          onClick={function () {
            onFilter({attr, value: ''})
          }}
        >
          {filterIcon}
          <div style={{marginLeft: 5}}>
            {attr}
          </div>
          <div style={{marginLeft: 5}}>{value}</div>
        </Widget>
      )
    }
  })

  const leftBar = Bar
    ? (<Bar counterWidget={counterWidget} filterWidgets={filterWidgets} />
    ) : [counterWidget, ...filterWidgets]

  return (
    <div style={barStyle}>
      <div style={barLeftStyle}>
        {leftBar}
      </div>
      {!smallScreen && children != null ? (
        <div style={barRightStyle}>
          {children}
        </div>
      ) : null}
    </div>
  )
}

TableBar.propTypes = {
  selectedRecords: selectedRecordsPropTypes,
  children: PropTypes.node,
  onClearSelection: PropTypes.func,
  onFilter: PropTypes.func,
  filters: PropTypes.objectOf(PropTypes.string).isRequired,
  smallScreen: PropTypes.bool,
  hideSelectAll: PropTypes.bool,
  Bar: PropTypes.func,
}

export default TableBar
